import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'
import {
  Facebook as FacebookBase,
  Instagram as InstagramBase,
  LinkedIn as LinkedInBase,
  Twitter as TwitterBase,
  YouTube as YouTubeBase
} from '@mui/icons-material'

export const Root = styled(({ margin, ...props }) => <div {...props} />)`
  background-color: ${props => props.theme.palette.blue[15]};
  margin: ${props => props.margin};
  padding: 24px;
`

export const Content = styled(ContainerBase)``

export const GridContainer = styled(({ margin, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Logo = styled('img')`
  display: block;
  margin: 0 auto 24px;

  ${props => props.theme.breakpoints.up('md')} {
    margin: 12px 0;
    max-width: 150px;
  }
`

export const List = styled('ul')`
  padding: 0;
  margin: 0;
  list-style: none;
`

export const Item = styled('li')`
  color: ${props => props.theme.palette.brand.white};
  font-size: 12px;
  line-height: 32px;
  text-align: center;

  &:first-child {
    font-size: 14px;
  }

  &.rrss-container {
    display: flex;
    justify-content: center;
    margin: 16px 0;
  }

  ${props => props.theme.breakpoints.up('sm')} {
    text-align: left;

    &.rrss-container {
      justify-content: flex-start;
    }
  }
`

export const Link = styled('a')`
  text-decoration: underline;
  color: ${props => props.theme.palette.brand.white};

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }

  &:active {
    color: ${props => props.theme.palette.brand.white};
  }

  &:focus {
    color: ${props => props.theme.palette.brand.white};
  }

  &:visited {
    color: ${props => props.theme.palette.brand.white};
  }
`

export const Strong = styled('strong')``

export const FacebookIcon = styled(FacebookBase)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.white};
    height: 24px;
    width: 24px;
  }
`

export const TwitterIcon = styled(TwitterBase)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.white};
    height: 24px;
    margin: 0 8px;
    width: 24px;
  }
`

export const LinkedInIcon = styled(LinkedInBase)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.white};
    height: 24px;
    margin: 0 8px;
    width: 24px;
  }
`

export const YouTubeIcon = styled(YouTubeBase)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.white};
    height: 24px;
    margin: 0 8px;
    width: 24px;
  }
`

export const InstagramIcon = styled(InstagramBase)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.white};
    height: 24px;
    margin: 0 8px;
    width: 24px;
  }
`
